<p-treeTable #tabGest [value]="allRows" [paginator]="true" [rows]="20" [alwaysShowPaginator]="false"
  (onNodeExpand)="sortChildren($event)" [globalFilterFields]="['descrizione','note']">
  <ng-template pTemplate="header">
    <tr>
      <th class="width60" [rowSpan]="2"></th>
      <th class="width160">Numero</th>
      <th>Descrizione</th>
      <th class="width160" [rowSpan]="2"></th>
    </tr>
    <tr>
      <th>
        <input class="width100p" placeholder="Filtra fascicolo..." pInputText type="text"
          (input)="tabGest.filter($event.target.value, 'sigla', 'contains')">
      </th>
      <th>
        <input class="width100p" pInputText type="text" placeholder="Filtra per descrizione e note..."
          (input)="tabGest.filterGlobal($event.target.value, 'contains')">
      </th>
    </tr>
  </ng-template>
  <ng-template let-i="rowIndex" pTemplate="body" let-rowNode let-rowData="rowData">
    <tr>
      <td class="centerText">
        <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
      </td>
      <td [class]="'trunc level' + rowData.level" [title]="rowData.sigla.length > 16 ? rowData.sigla : ''">
        {{rowData.sigla }}
      </td>
      <td [class]="'trunc desclevel' + rowData.level" [title]="rowData.descrizione?.length > 60 ? rowData.descrizione : ''">
        {{rowData.descrizione }}
      </td>
      <td class="center">
        <div class="d-flex">
          <ng-container *hasClaim="GassClaims.DocSpostamento">
            <div class="width35">
              <button *ngIf="!rowData.chiuso && rowData.level !== 0" pButton type="button"
              icon="fa fa-exchange" class="p-button-success" title="Sposta"
              (click)="moveNodePosition(rowData)"></button>
            </div>
          </ng-container>

          <div class="width35">
            <button *ngIf="!rowData.chiuso && rowData.level < hierarchyLastLevel" pButton type="button"
              icon="fa fa-plus" class="p-button-success" title="Aggiungi all'interno"
              (click)="addInRow(rowData)"></button>
          </div>

          <div class="width35">
            <button *ngIf="!rowData.chiuso || rowData.level === fascicoloLevel" pButton title="Modifica" type="button"
              icon="fa fa-pencil" class="p-button-warning" (click)="modRow(rowData)"></button>
          </div>

          <div class="width35">
            <button *ngIf="rowData.level === fascicoloLevel" pButton type="button" title="Scarica XML aggregazione"
              icon="fas fa-file-code" class="p-button-secondary" (click)="downloadXml(rowData)"></button>
          </div>

          <div class="width35">
            <button *ngIf="rowData.chiuso && rowData.level === fascicoloLevel" pButton type="button" title="Chiuso"
              icon="pi pi-lock" class="p-button-danger" disabled></button>
            <button *ngIf="!rowData.chiuso" pButton icon="fas fa-file" class="nuovo-documento"
              title="Nuovo documento in questa posizione" (click)="selectedDocument(rowNode)"></button>
          </div>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">Nessuna fascicolo trovato</td>
    </tr>
  </ng-template>
</p-treeTable>
